import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Divider } from "@ddm-design-system/divider";
import { ModalTooltip } from "@ddm-design-system/modal";
import useContent from "../../hooks/useContent";
import InfoModalItem from "../common/info_modal_item/InfoModalItem";
import "./recent-sales-info.scss";
import { isOutletChosen } from "../../store/filter/selectors";
import { AnalyticsContext } from "../../services/analytics";

const RecentSalesInfo: React.FC = () => {
  const { managerAppOverview: content, managerAppCommon: common } = useContent();
  const analytics = useContext(AnalyticsContext);
  const isOutletSet = useSelector(isOutletChosen);

  return (
    <ModalTooltip
      title={content.manager_app_live_performance}
      onAfterOpen={() => analytics.logEvent("TOOLTIP", "Recent Performance")}
      className="recent-sales-info"
    >
      {/**
       * Your Outlet
       */}
      <InfoModalItem iconName="keg" title={isOutletSet ? common.your_outlet : common.all_outlets}>
        {content.recent_performance_this_outlet_description}
      </InfoModalItem>
      <Divider />

      {/**
       * vs Similar Time
       */}
      <InfoModalItem iconName="average-positive" title={common.vs_similar_time}>
        {content.recent_performance_vs_similar_time_description}
      </InfoModalItem>
      <Divider />

      {/**
       * vs Target
       */}
      <InfoModalItem iconName="target" title={common.vs_target}>
        {content.recent_performance_vs_target_description}
      </InfoModalItem>
      <Divider />

      {/**
       * vs Similar Outlets
       */}
      {/* <InfoModalItem iconName="store" title={common.vs_similar_outlets}> */}
      {/*  {content.recent_performance_vs_similar_outlets_description} */}
      {/* </InfoModalItem> */}
      {/* <Divider /> */}

      {/**
       * vs Near Outlets
       */}
      {/* <InfoModalItem iconName="outlets" title={common.vs_near_outlets}> */}
      {/*  {content.recent_performance_vs_near_outlets_description} */}
      {/* </InfoModalItem> */}
    </ModalTooltip>
  );
};

export default RecentSalesInfo;
